// React & Hooks
import React, { useContext, useEffect, useState } from "react";

// Componentes locales
import PageContainer from "../../components/PageContainer/PageContainer";
import TableContainerQ from "../../components/TableBionovaQ/TableContainerQ/TableContainerQ";
import TableHeaderCellQ from "../../components/TableBionovaQ/TableHeaderCellQ/TableHeaderCellQ";
import TableBodyQ from "../../components/TableBionovaQ/TableBodyQ/TableBodyQ";
import TablePaginationQ from "../../components/TableBionovaQ/TablePaginationQ/TablePaginationQ";
import TableHeadQ from "../../components/TableBionovaQ/TableHeadQ/TableHeadQ";
import TableRowQ from "../../components/TableBionovaQ/TableRowQ/TableRowQ";
import TableRowCellQ from "../../components/TableBionovaQ/TableRowCellQ/TableRowCellQ";
import PackageDetail from "../../components/PackageDetail/PackageDetail";
import SelectQ from "../../components/FormComponents/SelectQ/SelectQ";
import FilterDate from "../../components/FilterDate/FilterDate";
import TruncatedText from "../../components/TableBionovaQ/TruncatedText/TruncatedText";
import SpinnerQ from "../../components/SpinnerQ/SpinnerQ";
import InputQ from "../../components/FormComponents/InputQ/InputQ";
import CircularProgressIndicators from "../../components/CircularProgressIndicators/CircularIndicator";
import PackageLabel from "../../components/packageLabel/PackageLabel";
import CheckBoxQ from "../../components/FormComponents/CheckBoxQ/CheckBoxQ";

// Utilidades y funciones auxiliares
import useTableQ from "../../utils/Hooks/useTableQ";
import useConfirmation from "../../utils/Hooks/useConfirmation/useConfirmation";
import LocalizationContext from "../../utils/LocalizationContext";
import request from "../../utils/request";
import df from "../../utils/dateFormater";
import { getRegionalFormat } from "../../utils/sessionHandler";
import parseFiltersDate from "../../utils/parseFiltersDate";
import t from "../../utils/translation";
import { getFilterValue, setFilterValue } from "../../utils/sessionFilters";
import printTicket from "../../utils/printTicket";
import Redirect from "../../utils/Redirect";

// Librerías externas
import { Tooltip } from "@material-ui/core";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

// Assets/Imágenes
import SterilizationImg from "../../assets/images/ICONO STERILIZATION NEW.svg";
import WashingImg from "../../assets/images/WASHING.svg";
import { LuPackageCheck } from "react-icons/lu";

// Estilos
import styles from "./ConsultPackage.module.css";
import { getScreenPermissions } from "../../utils/userPermissions";
import { toast } from "react-toastify";
import SelectSearch from "../../components/FormComponents/SelectSearch/SelectSearch";
import "sweetalert2/dist/sweetalert2.css";

const storagesArr = [
  { value: "", name: "" },
  { value: "storage_001", name: "Almacén Central" },
  { value: "storage_002", name: "Depósito Norte" },
  { value: "storage_003", name: "Bodega Sur" },
  { value: "storage_004", name: "Centro de Distribución" },
  { value: "storage_005", name: "Almacén Secundario" },
  { value: "storage_006", name: "Depósito de Materias Primas" },
  { value: "storage_007", name: "Bodega de Productos Terminados" },
  { value: "storage_008", name: "Depósito Express" },
  { value: "storage_009", name: "Centro Logístico" },
  { value: "storage_010", name: "Almacén Temporal" },
];

export default function ConsultPackage({ location, url }) {
  const [packages, setPackages] = useState([]);
  const [packageId, setPackageId] = useState(
    location?.state?.packageId ?? null
  );

  const [loadingPackages, setLoadingPackages] = useState(false);
  const [isDetailVisible, setIsDetailVisible] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [methods, setMethods] = useState([]);
  const [storages, setStorages] = useState(storagesArr);
  const [packageLocations, setPackageLocations] = useState([]);

  const filterName =
    url.toUpperCase() === "CONSULTPACKAGE"
      ? "consultPackage"
      : url.toUpperCase() === "MANAGEPACKAGES"
      ? "managePackages"
      : "releasePackages";
  const [filters, setFilters] = useState({
    packageNumber: getFilterValue("packageNumber", "", filterName),
    status: getFilterValue(
      "status",
      url.toUpperCase() === "MANAGEPACKAGES" ? 5 : "",
      filterName
    ),
    name: getFilterValue("name", "", filterName),
    method: getFilterValue("method", "", filterName),
    dateFrom: getFilterValue("dateFrom", "", filterName),
    dateTo: getFilterValue("dateTo", "", filterName),
    cycleNumber: getFilterValue("cycleNumber", "", filterName),
  });

  const locale = useContext(LocalizationContext);

  const { confirm } = useConfirmation();

  const getPackageLocation = async () => {
    try {
      let res = await request().get(`/api/location`);
      let format = res.data.map((l) => ({ value: l.id, name: l.locationName }));
      setPackageLocations(format);
    } catch (e) {
      toast.error(e.response?.data?.message);
    }
  };

  const fetchPackages = async (
    filters,

    setPackages,
    setTotalPages,
    currentPage,
    itemsPerPage
  ) => {
    setLoadingPackages(true);
    try {
      const {
        packageNumber = "",
        status = "",
        name = "",
        method = "",
        dateFrom = "",
        dateTo = "",
        cycleNumber = "",
      } = filters;

      const response = await request().get(
        `/api/Package/list?includeCount=true&pageSize=${itemsPerPage}&number=${packageNumber}&cycleNumber=${cycleNumber}&status=${status}&page=${currentPage}&search=${name}&method=${method}&dateFrom=${parseFiltersDate(
          df(dateFrom, "date"),
          getRegionalFormat().dateFormat
        )}&dateTo=${parseFiltersDate(
          df(dateTo, "date"),
          getRegionalFormat().dateFormat,
          true
        )}`
      );

      setPackages(response.data.packageList);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error("Error fetching packages:", error);
    } finally {
      setLoadingPackages(false);
    }
  };

  // Handlers for filter changes
  const handleFilterChange = (key, value) => {
    const updatedFilters = { ...filters, [key]: value };
    setFilters(updatedFilters);
    setFilterValue(key, value, filterName);
  };

  const handleSearch = (e) => handleFilterChange("name", e.target.value);
  const handlePackageNumber = (e) =>
    handleFilterChange("packageNumber", e.target.value);
  const handleCycleNumber = (e) =>
    handleFilterChange("cycleNumber", e.target.value);
  const handleStatus = (e) => handleFilterChange("status", e.target.value);
  const handleMethod = (e) => handleFilterChange("method", e.target.value);

  const handleDateChange = (type, value) => {
    if (type === "clear") {
      // Clear both dateFrom and dateTo
      const updatedDates = { dateFrom: "", dateTo: "" };
      setFilters((prevFilters) => {
        const newFilters = { ...prevFilters, ...updatedDates };
        // Save both dateFrom and dateTo in sessionStorage
        setFilterValue("dateFrom", "", filterName);
        setFilterValue("dateTo", "", filterName);
        return newFilters;
      });
    } else {
      // Update only one date
      setFilters((prevFilters) => {
        const newFilters = { ...prevFilters, [type]: value };
        setFilterValue(type, value, filterName);
        return newFilters;
      });
    }
  };

  // Fetch methods
  const getMethods = () => {
    request()
      .get("/api/method/1")
      .then((res) =>
        setMethods(
          res.data.map((m) => ({ value: m.id, name: m.methodTranslation }))
        )
      );
  };

  useEffect(() => {
    getMethods();
    getPackageLocation();
  }, []);

  const getStatusName = (packageValue) => {
    switch (packageValue) {
      case 1:
        return t("Assembling", locale);
      case 2:
        return t("ReadyForLoad", locale);
      case 3:
        return t("InLoad", locale);
      case 4:
        return t("Sterilized", locale);
      case 6:
        return t("BlankEntry126", locale) || "Released";
      case 7:
        return t("BlankEntry127", locale) || "BlankEntry127";
      case 8:
        return t("BlankEntry239", locale) || "Rejected in Area";
      case 9:
        return t("BlankEntry240", locale) || "Accepted in Area";
      case 10:
        return t("BlankEntry196", locale) || "Dispatched";
      case 11:
        return t("BlankEntry200", locale) || "Missing";
      case 12:
        return t("BlankEntry241", locale) || "Reception Completed";
      case 13:
        return t("BlankEntry242", locale) || "Reception Partial";
      default:
        return "Unknown Status";
    }
  };

  const handlePackageDetail = (packageGeneralId) => {
    const item = packages.find((p) => p.packageGeneralId === packageGeneralId);
    setPackageId(item.packageGeneralId);
    setIsDetailVisible(true);
  };

  const {
    currentPage,
    currentItems,
    itemsPerPage,
    handleChangePage,
    handleChangeItemsPerPage,
    handleSortByColumn,
    setCurrentPage,
  } = useTableQ(
    packages,
    ["packageNumber", "date", "description", "methodId", "packageStatus"],
    totalPages
  );

  const consultPackagesStatus = [
    { value: 1, name: t("Assembling", locale) },
    { value: 2, name: t("ReadyForLoad", locale) },
    { value: 3, name: t("InLoad", locale) },
    { value: 4, name: t("Sterilized", locale) },
    { value: 6, name: t("BlankEntry126", locale) || "Released" },
    { value: 7, name: t("BlankEntry127", locale) || "Rejected" },
    { value: 8, name: t("BlankEntry239", locale) || "Rejected in Area" },
    { value: 9, name: t("BlankEntry240", locale) || "Accepted in Area" },
    { value: 10, name: t("BlankEntry196", locale) || "Dispatched" },
    { value: 11, name: t("BlankEntry200", locale) || "Missing" },
    { value: 12, name: t("BlankEntry241", locale) || "Reception Completed" },
    { value: 13, name: t("BlankEntry242", locale) || "Reception Partial" },
  ];

  const managePackagesStatus = [
    { value: 5, name: t("SelectStatusOption") },
    { value: 1, name: t("Assembling", locale) },
    { value: 2, name: t("ReadyForLoad", locale) },
  ];

  const releasePackageStatus = [
    { value: 8, name: t("SelectStatusOption") },

    { value: 4, name: t("Sterilized", locale) },
    { value: 6, name: t("Release", locale) || "Release" },
  ];

  const arrayStatus =
    url.toUpperCase() === "CONSULTPACKAGE"
      ? consultPackagesStatus
      : url.toUpperCase() === "MANAGEPACKAGES"
      ? managePackagesStatus
      : releasePackageStatus;

  const showPrintAlert = (packageDetail, cycleInfo) => {
    const ReactSwal = withReactContent(Swal);
    ReactSwal.fire({
      html: (
        <PackageLabel packageDetail={packageDetail} cycleInfo={cycleInfo} />
      ),
      background: "var(--grey)",
      showConfirmButton: true,
      confirmButtonText: t("Print"),
    }).then((result) => {
      if (result.isConfirmed) {
        printTicket(packageDetail);
      }
    });
  };

  const getPrintPackage = (id, cycleInfo) => {
    request()
      .get(`/api/package/info?packageId=${id}`)
      .then((res) => showPrintAlert(res.data, cycleInfo));
  };

  const handleDelete = (packageGeneralId) => {
    const objectToDelete = packages.find(
      (pkg) => pkg.packageGeneralId === packageGeneralId
    );

    const adjustedObject = {
      ...objectToDelete,
      method: {
        name: objectToDelete.methodName,
      },
      creationDate: objectToDelete.date,
      id: objectToDelete.packageGeneralId,
    };
    request()
      .delete(`/api/package`, adjustedObject)
      .then(() => {
        const newData = packages.filter(
          (pkg) => pkg.packageGeneralId !== packageGeneralId
        );
        setPackages(newData);
      });
  };

  const onDelete = (packageGeneralId) => {
    confirm({
      title: "Are you sure?",
      text: t("DeleteConfirmationText"),
      icon: "warning",
      confirmButtonText: "Yes, delete it",
      cancelButtonText: "Cancel",
      onConfirm: () => handleDelete(packageGeneralId),
    });
  };

  useEffect(() => {
    fetchPackages(
      filters,

      setPackages,
      setTotalPages,
      currentPage,
      itemsPerPage
    );
  }, [filters, currentPage, itemsPerPage]);

  useEffect(() => {
    if (packageId) {
      setIsDetailVisible(true);
    }
  }, []);

  const modifyPackage = async (storage, packageId) => {
    try {
      await request().put(
        `/api/changeStorage?packageId=${packageId}&packageStatus=${storage}`
      );
      setPackages((prevPackages) =>
        prevPackages.map((pkg) =>
          pkg.packageGeneralId === packageId
            ? { ...pkg, storage: storage }
            : pkg
        )
      );
    } catch (error) {}
  };

  const releasePackage = async (packageNumber) => {
    // if (!getScreenPermissions("Release", "Release")) {
    //   return;
    // }

    const { value, isConfirmed } = await Swal.fire({
      title: "Are you sure to release the package?",
      input: "text",
      inputLabel: "Add a comment or additional info (optional)",
      showCancelButton: true,
      confirmButtonColor: "var(--primary-green)",
      cancelButtonColor: "#d33",
      confirmButtonText: "Confirm",
      cancelButtonText: "Cancel",
    });

    if (isConfirmed) {
      try {
        await request().put(
          `/api/package/release?packageNumber=${packageNumber}&observations=${value}`
        );

        fetchPackages(
          filters,

          setPackages,
          setTotalPages,
          currentPage,
          itemsPerPage
        );
      } catch (error) {
        toast.error(error?.response?.data?.message);
      }
    }
  };

  const selectStorage = async (e, packageNumber) => {
    let storageValue = e.target.value;
    try {
      await request().post(
        `/api/package/location?packageNumber=${packageNumber}&locationId=${storageValue}`
      );

      setPackages((prevPackages) =>
        prevPackages.map((pkg) =>
          pkg.packageNumber === packageNumber
            ? { ...pkg, locationId: storageValue }
            : pkg
        )
      );
    } catch (error) {
      toast.error("Failed");
    }
  };

  const getStatusColor = (id) => {
    return id === 1 ? "yellow" : "green";
  };

  return (
    <PageContainer
      categoryId={1}
      currentStep={
        url.toUpperCase() === "MANAGEPACKAGES"
          ? 1
          : url.toUpperCase() === "RELEASEPACKAGES"
          ? 4
          : null
      }
      category={t("SterilizationSpan")}
      backUrl={"/appsterilization"}
      title={
        url.toUpperCase() === "CONSULTPACKAGE"
          ? t("ConsultPackage", locale)
          : url.toUpperCase() === "MANAGEPACKAGES"
          ? t("ManagePackages", locale)
          : t("BlankEntry88")
      }
      subtitle={isDetailVisible ? t("DetailSpan") : null}
      clickBack={isDetailVisible ? true : null}
      onClickBack={() => setIsDetailVisible(false)}
      newButton={url.toUpperCase() === "MANAGEPACKAGES" && !isDetailVisible}
      newButtonUrl={"/appcreatepackages"}
      progress={url.toUpperCase() !== "CONSULTPACKAGE"}
    >
      <div
        className={
          url.toUpperCase() === "RELEASEPACKAGES"
            ? styles.releaseContainer
            : styles.container
        }
      >
        {!isDetailVisible ? (
          <div className={styles.tableContainer}>
            {url.toUpperCase() === "RELEASEPACKAGES" ? (
              <div className={styles.releaseFilter}>
                <InputQ
                  handleChange={handlePackageNumber}
                  placeholder={t("NumberSpan")}
                  value={filters.packageNumber}
                  containerWidth="300px"
                  hasPlaceholder={true}
                />
                <InputQ
                  handleChange={handleCycleNumber}
                  placeholder={t("CycleNumberSpan")}
                  value={filters.cycleNumber}
                  containerWidth="300px"
                  hasPlaceholder={true}
                />
              </div>
            ) : (
              <div className={styles.filterContainer}>
                <InputQ
                  handleChange={handlePackageNumber}
                  placeholder={t("NumberSpan")}
                  value={filters.packageNumber}
                  containerWidth="100%"
                  hasPlaceholder={true}
                />
                <FilterDate
                  handleChange={handleDateChange}
                  dateTo={filters.dateTo}
                  dateFrom={filters.dateFrom}
                />
                <InputQ
                  items={packages}
                  handleChange={handleSearch}
                  placeholder={t("NameSpan")}
                  value={filters.name}
                  containerWidth="100%"
                  hasPlaceholder={true}
                />
                <SelectQ
                  placeholder={t("SelectMethodOption")}
                  options={methods}
                  handleSelect={handleMethod}
                  selectValue={filters.method}
                  containerWidth={"100%"}
                  hasPlaceholder={true}
                />
                <SelectQ
                  placeholder={t("SelectStatusOption")}
                  hasPlaceholder={true}
                  options={arrayStatus}
                  handleSelect={handleStatus}
                  selectValue={filters.status}
                  containerWidth={"100%"}
                />
              </div>
            )}

            <TableContainerQ>
              <TableHeadQ
                actions={true}
                progress={url.toUpperCase() === "CONSULTPACKAGE"}
              >
                <TableHeaderCellQ
                  handleClick={() => handleSortByColumn("packageNumber")}
                >
                  {t("NumberSpan")}
                </TableHeaderCellQ>
                <TableHeaderCellQ
                  handleClick={() => handleSortByColumn("date")}
                >
                  {t("DateSpan")}
                </TableHeaderCellQ>
                <TableHeaderCellQ
                  handleClick={() => handleSortByColumn("description")}
                >
                  {t("NameSpan")}
                </TableHeaderCellQ>
                {url.toUpperCase() !== "RELEASEPACKAGES" && (
                  <TableHeaderCellQ
                    handleClick={() => handleSortByColumn("methodName")}
                  >
                    {t("MethodSpan")}
                  </TableHeaderCellQ>
                )}
                <TableHeaderCellQ
                  handleClick={() => handleSortByColumn("packageStatus")}
                >
                  {t("StatusSpan")}
                </TableHeaderCellQ>
                {/* {url.toUpperCase() === "RELEASEPACKAGES" && (
                  <TableHeaderCellQ>{t("BlankEntry85")}</TableHeaderCellQ>
                )} */}
                {url.toUpperCase() === "RELEASEPACKAGES" && (
                  <TableHeaderCellQ
                    handleClick={() => handleSortByColumn("chargeCycleNumber")}
                  >
                    {t("CycleNumberSpan")}
                  </TableHeaderCellQ>
                )}
                {url.toUpperCase() === "RELEASEPACKAGES" && (
                  <TableHeaderCellQ>
                    {t("ObservationReleased") || "Observation Released"}
                  </TableHeaderCellQ>
                )}
                {url.toUpperCase() === "RELEASEPACKAGES" && (
                  <TableHeaderCellQ>{t("BlankEntry86")}</TableHeaderCellQ>
                )}
                {url.toUpperCase() === "RELEASEPACKAGES" && (
                  <TableHeaderCellQ>{t("BlankEntry87")}</TableHeaderCellQ>
                )}
                {/* <TableHeaderCellQ
                  handleClick={() => handleSortByColumn("chargeCycleNumber")}
                >
                  {t("CycleNumberSpan")}
                </TableHeaderCellQ> */}
              </TableHeadQ>
              {loadingPackages ? (
                <div className="spinnerContainer">
                  <SpinnerQ />
                </div>
              ) : (
                <TableBodyQ>
                  {currentItems.map((p) => (
                    <TableRowQ
                      key={p.packageGeneralId}
                      progress={
                        url.toUpperCase() === "CONSULTPACKAGE" ? (
                          <CircularProgressIndicators
                            totalIndicators={p.totalIndicators}
                            vinculatedIndicators={p.vinculatedIndicators}
                            hasPositive={p.hasPositive}
                          />
                        ) : (
                          false
                        )
                      }
                      actions={true}
                      detail={p.packageStatus}
                      onClick={() => handlePackageDetail(p.packageGeneralId)}
                      onDetail={() => handlePackageDetail(p.packageGeneralId)}
                      print={p.packageStatus !== 1}
                      deleteRow={url.toUpperCase() === "MANAGEPACKAGES"}
                      onPrint={() =>
                        getPrintPackage(
                          p.packageGeneralId,
                          p.packageStatus === 4 || p.packageStatus === 6
                            ? true
                            : false
                        )
                      }
                      onDelete={() => onDelete(p.packageGeneralId)}
                      edit={
                        p.packageStatus === 1 &&
                        url.toUpperCase() === "MANAGEPACKAGES"
                      }
                      onEdit={() =>
                        Redirect({
                          redirect: true,
                          path: "/appcreatepackages",
                          parameters: { packageEditId: p.packageGeneralId },
                        })
                      }
                    >
                      <TableRowCellQ>
                        <span style={{ fontWeight: 500, fontSize: "0.875rem" }}>
                          {p.packageNumber}
                        </span>
                      </TableRowCellQ>
                      <TableRowCellQ>
                        <TruncatedText
                          text={df(p.date, "date")}
                          maxLength={25}
                        />
                      </TableRowCellQ>
                      <TableRowCellQ>
                        <TruncatedText text={p.description} maxLength={25} />
                      </TableRowCellQ>
                      {url.toUpperCase() !== "RELEASEPACKAGES" && (
                        <TableRowCellQ>
                          <TruncatedText text={p.methodName} maxLength={25} />
                        </TableRowCellQ>
                      )}
                      <TableRowCellQ>
                        {url.toUpperCase() === "MANAGEPACKAGES" && (
                          <span
                            className={`${styles.statusColor} ${
                              styles[getStatusColor(p.packageStatus)]
                            }`}
                          ></span>
                        )}
                        <TruncatedText
                          text={getStatusName(p.packageStatus)}
                          maxLength={25}
                        />
                        {p.packageStatus === 4 &&
                          url.toUpperCase() !== "RELEASEPACKAGES" && (
                            <span className={styles.cycleWithCircle}>
                              <span className={styles.thickParenthesis}>(</span>
                              <span className={styles.cycleLabel}>
                                {t("CycleNumberSpan")}:
                              </span>
                              <span className={styles.cycleNumber}>
                                {p.chargeCycleNumber}
                              </span>
                              <Tooltip
                                title={
                                  <span>
                                    {p.chargeHasPositive
                                      ? t("BlankEntry18")
                                      : t("BlankEntry19")}
                                  </span>
                                }
                                arrow
                              >
                                <div
                                  className={`${styles.circle} ${
                                    p.chargeHasPositive
                                      ? styles.red
                                      : p.chargeIndicatorsUnlinked
                                      ? styles.gray
                                      : styles.green
                                  }`}
                                ></div>
                              </Tooltip>
                              <span className={styles.thickParenthesis}>)</span>
                            </span>
                          )}
                      </TableRowCellQ>
                      {/* {url.toUpperCase() === "RELEASEPACKAGES" && (
                        <TableRowCellQ>
                          <div className={styles.remakePackagesContainer}>
                            <img
                              src={WashingImg}
                              className={`${styles.remakeButton} ${styles.washing}`}
                            />
                            <img
                              src={SterilizationImg}
                              className={`${styles.remakeButton} ${styles.sterilization}`}
                            />
                          </div>
                        </TableRowCellQ>
                      )} */}

                      {url.toUpperCase() === "RELEASEPACKAGES" && (
                        <TableRowCellQ>
                          <span className={styles.cycleWithCircle}>
                            <span className={styles.cycleNumber}>
                              {p.chargeCycleNumber}
                            </span>
                            <Tooltip
                              title={
                                <span>
                                  {p.chargeHasPositive
                                    ? t("BlankEntry18")
                                    : t("BlankEntry19")}
                                </span>
                              }
                              arrow
                            >
                              <div
                                className={`${styles.circle} ${
                                  p.chargeHasPositive
                                    ? styles.red
                                    : p.chargeIndicatorsUnlinked
                                    ? styles.gray
                                    : styles.green
                                }`}
                              ></div>
                            </Tooltip>
                          </span>
                        </TableRowCellQ>
                      )}
                      {url.toUpperCase() === "RELEASEPACKAGES" && (
                        <TableRowCellQ>
                          <TruncatedText
                            text={p.observationsReleased}
                            maxLength={25}
                          />
                        </TableRowCellQ>
                      )}
                      {url.toUpperCase() === "RELEASEPACKAGES" && (
                        <TableRowCellQ>
                          <div
                            className={styles.actionsRelease}
                            onClick={(e) => e.stopPropagation()}
                          >
                            <SelectQ
                              options={packageLocations}
                              handleSelect={(e) =>
                                selectStorage(e, p.packageNumber)
                              }
                              hasPlaceholder={true}
                              placeholder={"No Location"}
                              selectValue={p.locationId}
                              containerWidth={"100%"}
                              disabled={p.packageStatus !== 6}
                            />

                            {/* <SelectSearch
                              value={p.storageId}
                              placeholder={"No Location"}
                              name={"locationId"}
                              options={packageLocations}
                              onOptionSelect={selectStorage}
                              idProp={"id"}
                              labelProp={"locationName"}
                              disabled={p.status !== 6}
                            /> */}
                          </div>
                        </TableRowCellQ>
                      )}
                      {url.toUpperCase() === "RELEASEPACKAGES" && (
                        <div
                          className={styles.actionsRelease}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <TableRowCellQ>
                            {/* <CheckBoxQ
                              name={"release"}
                              checked={p.packageStatus === 6}
                              onChange={() =>
                                releasePackage(
                                  p.packageGeneralId,
                                  p.packageStatus === 6 ? 4 : 6
                                )
                              }
                            /> */}
                            <div
                              className={`${styles.remakeButton} ${
                                styles.sterilization
                              } ${styles.icon} ${
                                p.packageStatus === 6 ? styles.disabled : ""
                              }`}
                              onClick={() => releasePackage(p.packageNumber)}
                            >
                              <LuPackageCheck />
                            </div>
                          </TableRowCellQ>
                        </div>
                      )}
                    </TableRowQ>
                  ))}
                </TableBodyQ>
              )}
              <TablePaginationQ
                handleChangePage={handleChangePage}
                handleChangeItemsPerPage={handleChangeItemsPerPage}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalPages={totalPages}
                itemsPerPage={itemsPerPage}
                getPackages={fetchPackages}
              />
            </TableContainerQ>
          </div>
        ) : (
          <div className={styles.detailContainer}>
            <PackageDetail
              packageId={packageId}
              locale={locale}
              storage={false}
            />
          </div>
        )}
      </div>
    </PageContainer>
  );
}
